import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleStep: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '26px',
      color: theme.oysterTheme.pine,
    },
    subtitleStep: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      fontSize: '1rem',
      color: '#707070',
      marginTop: '13px',
    },
    card: {
      display: 'flex',
      background: '#FFFFFF',
      borderRadius: '10px',
      flexDirection: 'column',
      marginTop: '39px',
    },
    containerStepper: {
      padding: '14px',
      borderBottom: `1.9px solid ${theme.oysterTheme.stone}`,
      '&.MuiStepButton-root': {
        cursor: 'none !important',
      },
    },
    containerSubtitle: {
      padding: '35px',
      display: 'flex',
      flexDirection: 'column',
      whiteSpace: 'break-spaces',
    },
    stepper: {},
  }),
);

export default useStyles;
